import {
  CheckOutlined,
  CloseOutlined,
  DeleteOutlined,
  EditOutlined,
  MinusOutlined,
  PlusOutlined
} from '@ant-design/icons'
import { State, useHookstate } from '@hookstate/core'
import { Button, Col, Input, Popover, Row } from 'antd'
import styled from 'styled-components'
import { ITEM_STATES, JobProductItem } from '../../../../domain/items'
import { useEffect } from 'react'

const ItemActionSection = styled.div`
  border: solid 0.1rem #f0f2f5;
  height: 3.2rem;
  border-radius: 0.8rem;
  width: 11rem;
  float: right;
  & > div {
    margin-top: 0.3rem;
    & > div:nth-child(1) {
      & > button {
        border: none;
        background: none;
      }
    }
    & > div:nth-child(2) {
    }
    & > div:nth-child(3) {
      & > button {
        border: none;
        background: none;
      }
    }
  }
`

const FiledForEditItemSection = styled.div`
  border: solid 0.1rem #f0f2f5;
  height: 3.2rem;
  border-radius: 0.8rem;
  width: 11rem;
  float: right;
  & > div {
    margin-top: 0.3rem;
    & > div:nth-child(1) {
      & > button {
        border: none;
        background: none;
      }
    }
    & > div:nth-child(2) {
      & > input {
        text-align: center;
        border: none;
        &:focus {
          box-shadow: none;
        }
      }
    }
    & > div:nth-child(3) {
      & > button {
        border: none;
        background: none;
      }
    }
  }
`

type JobItemCardActionsProps = {
  jobProductItem: State<JobProductItem>
  selectedItemsTab: string
}

const JobItemCardActions = (props: JobItemCardActionsProps) => {
  const { jobProductItem, selectedItemsTab } = props
  const jobItem = useHookstate<JobProductItem>({} as JobProductItem)
  const showActionButtons = useHookstate<boolean>(false)
  const showFiledForEditItem = useHookstate<boolean>(false)

  useEffect(() => {
    jobItem.set(jobProductItem.get({ noproxy: true }))
  }, [])

  const onMouseEnterAction = () => {
    if (selectedItemsTab === ITEM_STATES.PENDING) {
      showActionButtons.set(true)
    }
  }

  const onMouseLeaveAction = () => {
    showActionButtons.set(false)
  }

  const onCancelEditItemQuantity = () => {
    jobItem.set(jobProductItem.get({ noproxy: true }))

    showActionButtons.set(false)
    showFiledForEditItem.set(false)
  }
  const onSaveEditItemQuantity = () => {
    onCancelEditItemQuantity()
  }

  const renderActionButtonsPopoverContent = (): React.ReactElement => {
    return (
      <Row gutter={16}>
        <Col span={12}>
          <Button type='default' size='small' onClick={onCancelEditItemQuantity}>
            <CloseOutlined />
          </Button>
        </Col>
        <Col span={12}>
          <Button type='default' size='small' onClick={onSaveEditItemQuantity}>
            <CheckOutlined />
          </Button>
        </Col>
      </Row>
    )
  }

  return (
    <>
      {!showFiledForEditItem.get() && (
        <ItemActionSection onMouseEnter={onMouseEnterAction} onMouseLeave={onMouseLeaveAction}>
          <Row>
            <Col span={7}>
              {showActionButtons.get() && (
                <Button type='default' size='small'>
                  <DeleteOutlined />
                </Button>
              )}
            </Col>
            <Col span={10}>
              <span>{jobItem.get().quantity}</span>
            </Col>
            <Col span={7}>
              {showActionButtons.get() && (
                <Button type='default' size='small'>
                  <EditOutlined onClick={() => showFiledForEditItem.set(true)} />
                </Button>
              )}
            </Col>
          </Row>
        </ItemActionSection>
      )}
      {showFiledForEditItem.get() && (
        <Popover placement='top' content={renderActionButtonsPopoverContent} trigger='click' visible>
          <FiledForEditItemSection>
            <Row>
              <Col span={7}>
                {showActionButtons.get() && jobItem.get().quantity > 1 && (
                  <Button
                    type='default'
                    size='small'
                    onClick={() => {
                      jobItem.set({ ...jobItem.get({ noproxy: true }), quantity: jobItem.get().quantity - 1 })
                    }}
                  >
                    <MinusOutlined />
                  </Button>
                )}
                {showActionButtons.get() && jobItem.get().quantity === 1 && (
                  <Button type='default' size='small'>
                    <DeleteOutlined />
                  </Button>
                )}
              </Col>
              <Col span={10}>
                <Input value={jobItem.get().quantity} size='small'></Input>
              </Col>
              <Col span={7}>
                {showActionButtons.get() && (
                  <Button
                    type='default'
                    size='small'
                    onClick={() => {
                      jobItem.set({ ...jobItem.get({ noproxy: true }), quantity: jobItem.get().quantity + 1 })
                    }}
                  >
                    <PlusOutlined />
                  </Button>
                )}
              </Col>
            </Row>
          </FiledForEditItemSection>
        </Popover>
      )}
    </>
  )
}

export { JobItemCardActions }
